// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__dvzdr","radioBtn":"styles_radioBtn__YpPaU","price":"styles_price__HNAz8","accent":"styles_accent__NHhmL"};